import { memo } from 'react';

import AdminRoleIconSVG from '@/assets/admin-role-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAdminRoleIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AdminRoleIconSVG} {...props} />;

export const AdminRoleIcon = memo(IAdminRoleIcon) as typeof IAdminRoleIcon;
